export type Size = 'sm' | 'md' | 'lg'

export const SIZE_MAP: Record<Size, 'small' | 'middle' | 'large'> = {
  sm: 'small',
  md: 'middle',
  lg: 'large'
}
